import React from 'react';
import Button from '@material-ui/core/Button';
import type { Theme } from '@material-ui/core/styles/createMuiTheme';
import type { WithStyles } from '@material-ui/core/styles/withStyles';
import createStyles from '@material-ui/styles/createStyles';
import { PostWindowMessageStatus } from '../common/constants';
import { postWindowMessage } from '../common/utilities';
import { colors } from '../theme';
import Tag from './common/Tag';

interface ISubmissionInteractionsProps extends WithStyles<typeof _styles> {
  termsAccepted: boolean;
  completed: boolean;
  alreadySigned: boolean;
  screenWidthIsLessThanOrEqualToMdBreakpoint: boolean;
  requiredFieldsTotal: number;
  requiredFieldsSigned: number;
  currentBlockIndex: number | null;
  onMouseUp: (e: any) => void;
  onTouchEnd: (e: any) => void;
}

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
const _styles = (theme: Theme) =>
  createStyles({
    rightSide: {
      display: 'flex',
      color: colors.dusk,
      alignItems: 'center',
    },
    rideSideMdScreen: {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      justifyContent: 'center',
      maxHeight: '44px',
    },
    fieldsText: {
      marginLeft: theme.spacing(),
      marginRight: theme.spacing(2),
    },
    menuStyle: {
      zIndex: 10000,
      top: '-2px !important',
      borderRadius: 0,
      marginLeft: '9px',
    },
    responsiveSubmitBtn: {
      width: '60%',
      whiteSpace: 'pre',
      '&:active': {
        backgroundColor: '#1537BB',
      },
    },
  });

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const SubmissionInteractions = (props: ISubmissionInteractionsProps) => {
  const {
    termsAccepted,
    completed,
    alreadySigned,
    screenWidthIsLessThanOrEqualToMdBreakpoint,
    requiredFieldsSigned,
    requiredFieldsTotal,
    onMouseUp,
    onTouchEnd,
    classes,
    currentBlockIndex,
  } = props;
  const isDisabled = !termsAccepted || !completed || alreadySigned;
  const submitBtnClass = screenWidthIsLessThanOrEqualToMdBreakpoint ? classes.responsiveSubmitBtn : undefined;
  const rightSideClass = screenWidthIsLessThanOrEqualToMdBreakpoint ? classes.rideSideMdScreen : classes.rightSide;
  let buttonText = 'Finish Signing';
  if (!screenWidthIsLessThanOrEqualToMdBreakpoint) {
    if (alreadySigned) return null;
    return (
      <div className={classes.rightSide}>
        <Tag color={completed ? 'green' : undefined}>{completed ? <>&#10003;</> : ''}</Tag>
        <div className={classes.fieldsText}>
          Required Fields Completed:{' '}
          <b>
            {alreadySigned ? requiredFieldsTotal : requiredFieldsSigned} / {requiredFieldsTotal}
          </b>
        </div>
        <Button
          className={submitBtnClass}
          variant="contained"
          color="primary"
          disabled={isDisabled}
          onMouseUp={onMouseUp}
          onTouchEnd={onTouchEnd}
          disableRipple={screenWidthIsLessThanOrEqualToMdBreakpoint ? true : false}
        >
          {buttonText}
        </Button>
      </div>
    );
  }
  let buttonDisabled = false;
  if (screenWidthIsLessThanOrEqualToMdBreakpoint) {
    if (currentBlockIndex !== null) {
      buttonText = 'Next';
    } else if (currentBlockIndex === null) {
      buttonText = 'Start';
    }
    if (completed) {
      buttonText = 'Finish Signing';
      postWindowMessage({
        header_text: 'Documents to Sign',
        back_button_type: '<',
        should_back_button_exit: false,
        button_text: 'Sign & Next',
        digi_mobile_status: PostWindowMessageStatus.SIGNING_IN_PROGRESS,
      });
    }
  }
  if (screenWidthIsLessThanOrEqualToMdBreakpoint && !alreadySigned) {
    return (
      <div className={rightSideClass}>
        <Tag color={completed ? 'green' : undefined}>{completed ? <>&#10003;</> : ''}</Tag>
        <div className={classes.fieldsText}>
          {screenWidthIsLessThanOrEqualToMdBreakpoint ? '' : 'Required Fields Completed:'}{' '}
          <b>
            {alreadySigned ? props.requiredFieldsTotal : props.requiredFieldsSigned} / {props.requiredFieldsTotal}
          </b>
        </div>
        <Button
          className={submitBtnClass}
          variant="contained"
          color="primary"
          disabled={screenWidthIsLessThanOrEqualToMdBreakpoint ? buttonDisabled : isDisabled}
          onMouseUp={onMouseUp}
          onTouchEnd={onTouchEnd}
          disableRipple={screenWidthIsLessThanOrEqualToMdBreakpoint ? true : false}
        >
          {buttonText}
        </Button>
      </div>
    );
  }
  return null;
};

// eslint-disable-next-line import/no-default-export -- This code was written prior to enforcing lint rules
export default SubmissionInteractions;
